export default __webpack_public_path__ + "static/media/bg-large-blue.c193ddff.svg";